import React from 'react';

type Size = 'sm' | 'md' | 'lg';

const dim: Record<Size, string> = {
  sm: 'h-[26px] w-[26px] rounded-[13px] text-[10.4px] tracking-[-0.104px]',
  md: 'h-8 w-8 rounded-2xl text-xs tracking-[-0.1px]',
  lg: 'h-9 w-9 rounded-[18px] text-[14.4px] tracking-[-0.144px]',
};

const gradients = [
  'linear-gradient(135deg, rgb(229, 201, 247) 0%, rgb(156, 107, 211) 100%)',
  'linear-gradient(135deg, rgb(255, 183, 225) 0%, rgb(235, 66, 178) 100%)',
  'linear-gradient(135deg, rgb(255, 214, 184) 0%, rgb(255, 140, 92) 100%)',
  'linear-gradient(135deg, rgb(191, 229, 197) 0%, rgb(91, 168, 118) 100%)',
  'linear-gradient(135deg, rgb(255, 228, 138) 0%, rgb(244, 167, 66) 100%)',
];

const lettersDefault = ['M', 'L', 'A', 'J', 'S'];

const ring: Record<Size, string> = {
  sm: 'shadow-[0px_0px_0px_2px_white]',
  md: 'shadow-[0px_0px_0px_2px_white]',
  lg: 'shadow-[0px_0px_0px_2.5px_white]',
};

type AvatarStackProps = {
  size?: Size;
  className?: string;
  letters?: string[];
};

const AvatarStack: React.FC<AvatarStackProps> = ({ size = 'md', className = '', letters }) => {
  const L = letters ?? lettersDefault;
  const overlap = size === 'lg' ? 'mr-[-10px]' : 'mr-[-8px]';

  return (
    <div className={`flex items-center ${className}`}>
      {L.map((letter, i) => (
        <div
          key={`${letter}-${i}`}
          className={`relative flex shrink-0 items-center justify-center font-bold text-white/95 ${dim[size]} ${i < L.length - 1 ? overlap : ''}`}
          style={{ backgroundImage: gradients[i] }}
        >
          <span
            className={`pointer-events-none absolute inset-0 rounded-[inherit] ${ring[size]}`}
            aria-hidden
          />
          <span className="relative font-jakarta">{letter}</span>
        </div>
      ))}
    </div>
  );
};

export default AvatarStack;
